import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class AgentlistapiService {

  WLID : any
  accountinfo:any
  baseUrl = 'https://api2.streamingtv.fun:3479/api'
  AngelaApi = 'https://api2.vrnlapi.live:3479'
  origin = environment.origin;

  
  constructor(private httpClient: HttpClient,private tokenservice:TokenService) {
    this.WLID = this.tokenservice.getWLIDDetail()

    // this.accountinfo = JSON.parse(localStorage.getItem('UserInfo'))
    // if(this.accountinfo){
    //   this.WLID = this.accountinfo.WLID
    // }
    
   }

  getAgentlist(WLID:any){
    return this.httpClient.get(`${this.baseUrl}/getAgentList/${WLID}`)
  }
  getAgentlistType(WLID:any,Type:any){
    return this.httpClient.get(`${this.baseUrl}/getAgentList/${WLID}/${Type}`)
  }
  deleteAgentlist(ID:any) {
    return this.httpClient.delete(`${this.baseUrl}/deleteAgent/${ID}`)
  }
  Updateagent(data:any,agID:any){
    return this.httpClient.put(`${this.baseUrl}/Updateagents/${agID}`,data)
  }
  addnewagent(id:any){
    return this.httpClient.post(`${this.baseUrl}/agents`,id)
  }
  LoginApi(data){
    return this.httpClient.post(`${this.baseUrl}/LoginAgent`,data)
  }

  proxylink(data){
    return this.httpClient.post(`${this.baseUrl}/proxylink`,data)
  }
  GetProxyData(WLID){
    return this.httpClient.get(`${this.baseUrl}/getproxyLink/${WLID}`)
  }
  deleteproxyData(ID:any){
    return this.httpClient.delete(`${this.baseUrl}/deleteproxyLink/${ID}`)
  }

  changePassword(data: any) {
    return this.httpClient.put(`${this.baseUrl}/changepassword-agentList`, data);
  }
  
  getlotteryAgent(){
    return this.httpClient.get(`${this.baseUrl}/getlotteryAgent`)
  }
  getOldlotteryAgent(){
    return this.httpClient.get(`${this.baseUrl}/getlotteryAgentOld`)
  }
  updateLotteryResult(id: any,data:any) {
    return this.httpClient.put(`${this.baseUrl}/updateLotteryResult/${id}`, data);
  }
  deletelottery(ID:any){
    return this.httpClient.delete(`${this.baseUrl}/deleteLottery/${ID}`)
  }
  getChildren(ID: string) {
    return this.httpClient.get(`https://api2.streamingtv.fun:3479/api/getChildren?ID=${ID}`);
  }
  deleteHierarchy(ID:any){
    return this.httpClient.delete(`${this.baseUrl}/deleteHierarchy/${ID}`)
  }
  activeHierarchy(ID:any){
    return this.httpClient.put(`${this.baseUrl}/ActiveHierarchy/${ID}`, {})
  }
  AgentLatestUpdate(data){
    return this.httpClient.post(`${this.baseUrl}/AgentLatestUpdate`,data)
  }
  GetLatestUpdate(){
    return this.httpClient.get(`${this.baseUrl}/GetLatestUpdate/${this.origin}`)
  }
  DeleteLatestUpdate(ID:any){
    return this.httpClient.delete(`${this.baseUrl}/DeleteLatestUpdate/${ID}`)
  }
  updateProxy(id: any,data:any) {
    return this.httpClient.put(`${this.baseUrl}/editProxy/${id}`, data);
  }
  updatelatestUpdate(id: any,data:any) {
    return this.httpClient.put(`${this.baseUrl}/editLatestUpdate/${id}`, data);
  }
  getSocialLink() {
    return this.httpClient.get(`${this.AngelaApi}/api/getSocialLink`)
  }
  deleteSocial(id: any) {
    return this.httpClient.delete(`${this.AngelaApi}/api/deletSocial/${id}`)
  }
  editSocial(data: any, id: any) {
    return this.httpClient.put(`${this.AngelaApi}/api/EditSocial/${id}`, data)
  }
  updateSocial(id: any) {
    return this.httpClient.post(`${this.AngelaApi}/api/updateSocial`, id)
  }
  createQuiz(data: any) {
    return this.httpClient.post(`${this.AngelaApi}/createQuiz`, data);
  }

  addQuizQuestion(data: any) {
    return this.httpClient.post(`${this.AngelaApi}/addQuizQuestion`, data);
  }

  getQuizList() {
    return this.httpClient.get(`${this.AngelaApi}/getQuizList`);
  }

  getQuizDetails(quiz_id: number) {
    return this.httpClient.get(`${this.AngelaApi}/getQuizDetails?quiz_id=${quiz_id}`);
  }
  
  disableQuiz(payload: any) {
    return this.httpClient.post(`${this.AngelaApi}/disableQuiz`,payload);
  }

  updateQuiz(payload: any) {
    return this.httpClient.put(`${this.AngelaApi}/updateQuiz`, payload);
  }

  updateQuizQuestion(data: any) {
    return this.httpClient.put(`${this.AngelaApi}/updateQuizQuestion`, data);
  }

  deleteQuizQuestion(question_id: number) {
    return this.httpClient.delete(
      `${this.AngelaApi}/deleteQuizQuestion?question_id=${question_id}`
    );
  }

  getAllQuizReport(quiz_id?: number) {
    const url =
      quiz_id != null
        ? `${this.AngelaApi}/getAllQuizReport?quiz_id=${quiz_id}`
        : `${this.AngelaApi}/getAllQuizReport`;
    return this.httpClient.get(url);
  }

  getQuizReportBySubmissionId(submission_id: number) {
    return this.httpClient.get(
      `${this.AngelaApi}/getQuizReport?submission_id=${submission_id}`
    );
  }
  
  validateQuizBonus(payload: { quiz_id: number }) {
    return this.httpClient.post(`${this.AngelaApi}/validateQuizBonus`, payload);
  }

}
